import React, {useState} from "react";

import PropTypes from "prop-types";

// import eSignature from "../../resources/images/electronicIcon.svg";
import docVerifictaion from "../../resources/images/documentIcon.svg";
import livenesAndAge from "../../resources/images/livenessIcon.svg";
import {useTranslation} from "react-i18next";

import {
    StyledMainContainer,
    StyledDropDownContent,
    StyledLink,
    StyledButton,
    StyledIcon,
    StyledInnerContainer,
    StyledDescription,
    StyledTitle,
} from "./DropDownMenuStyle";

const DropDownMenu = ({darkColor, headerBackground}) => {
    const {t} = useTranslation();
    const [show, setShow] = useState(false);

    const onMouseEnter = () => setShow(true)
    const onMouseLeave = () => setTimeout(() => setShow(false), 300);

    return (
        <StyledMainContainer
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
        >
            <StyledButton
                headerBackground={headerBackground}
                darkColor={darkColor}
                onClick={() => setShow(!show)}
            >
                {t("Products")}
            </StyledButton>
            <StyledDropDownContent show={show}>
                <StyledLink to="/liveness-and-age">
                    <StyledIcon width='20' height='18'  src={livenesAndAge} alt=""/>
                    <StyledInnerContainer>
                        <StyledTitle>{t("LivenessCheckTitleHeader")}</StyledTitle>
                        <StyledDescription>{t("LivenessCheckDescHeader")}</StyledDescription>
                    </StyledInnerContainer>
                </StyledLink>
                <StyledLink to="/document-verification">
                    <StyledIcon width='20' height='18'  src={docVerifictaion} alt=""/>
                    <StyledInnerContainer>
                        <StyledTitle>{t("DocumentTitleHeader")}</StyledTitle>
                        <StyledDescription>{t("DocumentDescHeader")}</StyledDescription>
                    </StyledInnerContainer>
                </StyledLink>
                {/* <StyledLink to="/electronic-signature">
                    <StyledIcon width='20' height='18' src={eSignature} alt=""/>
                    <StyledInnerContainer>
                        <StyledTitle>{t("ESignatureTitleHeader")}</StyledTitle>
                        <StyledDescription>{t("ESignatureDescHeader")}</StyledDescription>
                    </StyledInnerContainer>
                </StyledLink> */}
            </StyledDropDownContent>
        </StyledMainContainer>
    );
};

DropDownMenu.propTypes = {
    value: PropTypes.string,
    onClick: PropTypes.func,
    headerBackground: PropTypes.bool,
};
export default DropDownMenu;
